import { useCallback, useEffect, useRef, useState } from 'react'

import { MainContainer } from './styles'
import Modal from 'components/Modal'
import { v4 as uuidv4 } from 'uuid'
import { useMenuFoodContext } from '../../contexts'
import { FormAddItem } from './components/FormAddItem'
import api from 'services/api'
import {
  apiDuplicateMenuFoodTemplates,
  apiListMenuFoodTemplates
} from '../../domain/api'
import { useLoading } from 'hooks/loading'

type TypesFormProps = {
  menu_food_id: number
}

type IMenuFoodTemplateMap = {
  [key: number]: {
    [key: string]: {
      id: number
      dishes_info: {
        id: string
        dish_id: number
        dish_name: string
        dish_type_id?: number
        dish_amount: any
        is_default_dish: boolean
        dish_type_name: string
        portion?: string
      }[]
    }
  }
}

const weekDays = {
  monday: 'Segunda',
  tuesday: 'Terça',
  wednesday: 'Quarta',
  thursday: 'Quinta',
  friday: 'Sexta'
}

const DEFAULT_WEEK_NUMBER = 6

export const TemplatesTab = ({ menu_food_id }: TypesFormProps): JSX.Element => {
  const { setTemplateComposition } = useMenuFoodContext()

  const [modalTypeOpenItems, setModalTypeOpenItems] = useState<{
    type: TModalType
    id?: number
    weekDay?: string
    weekDayLabel?: string
    week?: number
  }>({ type: 'closed' })

  const [menuFoodTemplatesMap, setMenuFoodTemplatesMap] =
    useState<IMenuFoodTemplateMap>()

  const refModalItems = useRef(null)

  const { activeLoading, disableLoading } = useLoading()

  const getMenuFoodTemplatesMap = useCallback(async () => {
    const response = await api.get(
      apiListMenuFoodTemplates(String(menu_food_id))
    )

    setMenuFoodTemplatesMap(response.data)
  }, [menu_food_id])

  const handleClickOnCloseItems = async () => {
    setModalTypeOpenItems({ type: 'closed' })
    activeLoading()
    await getMenuFoodTemplatesMap()

    setTemplateComposition([
      {
        id: uuidv4(),
        dish_id: undefined,
        dish_type_id: undefined,
        dish_amount: 1,
        dish_name: undefined,
        is_default_dish: false,
        dish_type_name: undefined,
        portion: undefined,
        week_day: undefined,
        week: undefined
      }
    ])
    disableLoading()
  }

  useEffect(() => {
    if (menu_food_id) {
      getMenuFoodTemplatesMap()
    }
  }, [menu_food_id, getMenuFoodTemplatesMap])

  return (
    <MainContainer>
      <h3>Templates do cardápio</h3>
      <div className="row mb-8">
        <button
          className="col-md-2"
          onClick={async () => {
            activeLoading()
            await api.post(apiDuplicateMenuFoodTemplates(), {
              menu_food_id
            })
            disableLoading()
            window.location.reload()
          }}
        >
          Duplicar
        </button>
      </div>

      <div className="row">
        <p className="col-md-1 row-title"></p>
        {Object.values(weekDays).map((day, index) => (
          <div key={index} className="col-md-1 text-center">
            <p>{day}</p>
          </div>
        ))}
      </div>
      {Array.from({ length: DEFAULT_WEEK_NUMBER }).map((_, weekNumber) => (
        <div className="row" key={weekNumber}>
          <p className="row-title">Semana {weekNumber + 1}</p>
          {Object.entries(weekDays).map(([key, value], index) => {
            const has = menuFoodTemplatesMap?.[weekNumber + 1]?.[key]
            return (
              <div key={index} className="col-md-1 text-center">
                <button
                  className={`btn ${has ? 'btn-info' : 'btn-primary'}`}
                  onClick={() => {
                    if (has) {
                      setTemplateComposition(
                        has.dishes_info.map(item => ({
                          id: uuidv4(),
                          dish_id: item.dish_id,
                          dish_amount: item.dish_amount,
                          dish_name: item.dish_name,
                          dish_type_id: item?.dish_type_id,
                          is_default_dish: item.is_default_dish,
                          dish_type_name: item.dish_type_name,
                          portion: item.portion,
                          week_day: key,
                          week: weekNumber + 1
                        }))
                      )
                    }
                    setModalTypeOpenItems({
                      type: has ? 'update' : 'create',
                      weekDay: key,
                      weekDayLabel: value,
                      week: weekNumber + 1,
                      id: has?.id
                    })
                  }}
                >
                  {has ? 'Editar' : 'Selecione'}
                </button>
              </div>
            )
          })}
        </div>
      ))}
      <Modal
        refModal={refModalItems}
        onClickButtonCancel={handleClickOnCloseItems}
        isOpenModal={modalTypeOpenItems.type !== 'closed'}
        pageTitle={
          modalTypeOpenItems.type === 'create' ? 'Adicionar' : 'Editar'
        }
        style={{
          stylesModal: {
            height: '100%',
            width: '80%'
          }
        }}
        withoutPadding={true}
        Children={
          <FormAddItem
            typeForm={
              modalTypeOpenItems.type === 'create' ? 'create' : 'update'
            }
            weekDay={modalTypeOpenItems.weekDay}
            weekDayLabel={modalTypeOpenItems.weekDayLabel}
            week={modalTypeOpenItems.week}
            isOpenInModal={{
              handleOnClose: handleClickOnCloseItems,
              idParent: Number(menu_food_id)
            }}
            actualMenuFoodDish={modalTypeOpenItems.id}
            menuFoodId={menu_food_id}
          />
        }
      />
    </MainContainer>
  )
}
